const environment = {
    envName: process.env.REACT_APP_ENV_NAME,
    production: false,
    baseUrl: process.env.REACT_APP_BASE_URL,
    apiVersion: process.env.REACT_APP_API_VERSION,
    auth: {
        App_Name: process.env.REACT_APP_AUTH_NAME || '',
        CLIENT_ID: process.env.REACT_APP_AUTH_CLIENT_ID || '',
        CLIENT_DOMAIN: process.env.REACT_APP_AUTH_CLIENT_DOMAIN || '',
        REDIRECT: process.env.REACT_APP_AUTH_REDIRECT_URL || window.location.origin,
        LOGOUT_URL: process.env.REACT_APP_AUTH_REDIRECT_URL|| '',
        CACHE_LOCATION: 'localstorage',
        USE_REFRESH_TOKENS: true,
    }
}

export default environment;